import React, { useState } from "react";
import Button from "components/button";
import IndexModal from "components/modal";
import { Eye } from "lucide-react";

const ViewButton = ({
    children, 
    buttonClass 
}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <Button
                onClick={() => setIsOpen(true)}
                className={`inline-flex items-center justify-center font-medium hover:bg-slate-50 hover:shadow-none rounded-lg gap-1.5 h-8 px-3 text-[12px] ${buttonClass || ""}`}
            >
                <Eye className="w-3 h-3 mr-1" />
                <span>View</span>
            </Button>

            <IndexModal
                open={isOpen}
                onClose={() => setIsOpen(false)}
                useCustomClass={true}
                maxContentHeight="85vh"
                width="sm:max-w-lg max-w-2xl"
            >
                {children}
            </IndexModal>
        </>
    );
};

export default ViewButton;
